
export default function filter_table_admin_orders_history(header, value) {
    if (header === 'ID_client') return {mode: 'link', content: value[header]};
    if (header === 'order_number') return {mode: 'info_icon', content: value[header]};
    if (header === 'created_at' || header === 'updated_at') {

        let date = 'unknown';
        if (value[header] !== null && typeof value[header] !== 'undefined') {
           date = value[header].replace('T', ' ').slice(0, 16);
        } else {
            if (header === 'created_at' && value[header] === null) {
                date = Object.keys(value).includes('createdTime') && value.createdTime !== null && value.createdTime !== '' ? value.createdTime.replace('T', ' ').slice(0, 16) : date;
            }
        }
        return {mode: 'info', content: date};
    }
    if (header === 'process-retoucher') {
        let retoucher = value && value[header] === '' ? value[header] :  (value.process_retoucher) ?  value.process_retoucher.email : '';
        return {mode: 'info', content: retoucher};
    }
    if (header === 'finances') {
        let additional_services = 'no info';
        let basic_tarif = 'no info';
        let night_tarif = 'no info';
        let weekend_tarif = 'no info';
        let order_price = 'no info';
        if (Object.keys(value).includes(header) && value[header] !== null) {
            additional_services = Number (value[header].additional_services).toFixed(2);
            basic_tarif = Number (value[header].basic_tarif).toFixed(2);
            night_tarif = Number (value[header].night_tarif).toFixed(2);
            weekend_tarif = Number (value[header].weekend_tarif).toFixed(2);
            order_price = Number (value[header].order_price).toFixed(2);
        } else if (!Object.keys(value).includes(header)) {
            additional_services = Number (value.additional_services).toFixed(2);
            basic_tarif = Number (value.basic_tarif).toFixed(2);
            night_tarif = Number (value.night_tarif).toFixed(2);
            weekend_tarif = Number (value.weekend_tarif).toFixed(2);
            order_price = Number (value.order_price).toFixed(2);
        }

        let finances = [
            {additional_services},
            {basic_tarif},
            {night_tarif},
            {weekend_tarif},
        ];
        return {mode: 'dropdown', content: { order_price, finances}};
    }
    return {mode: 'info', content: value[header]};
}